import React from 'react';
import { connect } from 'react-redux';
import { incrementStep, decrementStep, setFormData } from '../redux/actions';
import { BackArrow } from "../../shared/svgIcons.jsx";
import TextInput from '../../shared/TextInput/index.jsx';
import ReactLib from '@owenscorning/react-library'
const { Connect: { FormElements: { Form } } } = ReactLib
import { StepWrapper, Header, BackWrapper, BackText } from '../styled-components'
import NextButton from '../../shared/next-button';
import { PREPAID_SQUARE_LIMIT } from '../constants';
import Complaint from '../../shared/Complaint';
import Warning from '../../shared/warning';
import WarrantyComplaint from '../../shared/Complaint/complaint';
import WarrantyCheckBox from '../../shared/Checkbox'

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const RoofSizeStep = ({ incrementStep, decrementStep, formData }) => {
  return (
    <StepWrapper>
      <Form onSubmit={incrementStep} data={formData}>
        <BackWrapper
          data-track="form-back"
          data-track-form-name="Warranty Registration"
          data-track-form-step="step 8 - how many total squares is the roof"
          onClick={decrementStep}>
          <BackArrow width="21" height="12" />
          <h3>Back</h3>
          <BackText>
            When was the roof installed?
          </BackText>
        </BackWrapper>
        <Header>How many total squares is the roof?</Header>
        <p>A typical 3 bedroom home is between 25 to 35 squares.</p>
        <p>Please round to the nearest whole number.</p>
        <Form.Requirement requireFunc={({ squares }) => [squares && squares.length >= 1, '']} >
          <TextInput
            fieldKey={'squares'}
            htmlAttributes={{
              placeholder: 'Total Squares',
              pattern: "[0-9]*",
              maxLength: 3
            }}
          />
        </Form.Requirement>
        <WarrantyComplaint
          requiredFields={['squares']}
          text={'Squares is required'} />
        {formData.squares && formData.squares > PREPAID_SQUARE_LIMIT && (
          <React.Fragment>
            <Complaint
              show={formData.squares && formData.squares > PREPAID_SQUARE_LIMIT}
              text={"That's a big roof! Did you enter square feet? 1 square is equal to 100 square feet. Please edit your entry or confirm."} />
            <WarrantyCheckBox
              fieldKey={'didAcknowledgeBigRoof'}
              text={"I confirm that my entry is accurate."}
            />

          </React.Fragment>

        )}
        <NextButton
          data-track="form-advance"
          data-track-form-name="Warranty Registration"
          data-track-form-step="step 8 - how many total squares is the roof"
        >Next</NextButton>
      </Form>
    </StepWrapper>
  )
};

const mapDispatchToProps = dispatch => (
  {
    incrementStep: () => dispatch(incrementStep()),
    decrementStep: () => dispatch(decrementStep()),
    setFormData: (hash) => dispatch(setFormData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RoofSizeStep);
